var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-input',{staticStyle:{"width":"55px","border":"1px solid gray","text-align":"right"},style:({color: _vm.$store.state.siteData.legColors[_vm.index]}),attrs:{"size":"sm"},model:{value:(_vm.mult),callback:function ($$v) {_vm.mult=_vm._n($$v)},expression:"mult"}})
}
var staticRenderFns = []

export { render, staticRenderFns }